module.exports = __webpack_public_path__ + "static/media/tübitak2017.7b3c4b1c.png";